import axios from "axios";
import getLogger from "../../logger/index";
const log = getLogger("DID_YOU_MEAN_REQUEST");
import config from "lib/config";
import { getDynamicRoute } from "util/createProfileIdPath";
export const DID_YOU_MEAN_REQUEST = "DID_YOU_MEAN_REQUEST";
export const DID_YOU_MEAN_SUCCESS = "DID_YOU_MEAN_SUCCESS";
export const DID_YOU_MEAN_FAILURE = "DID_YOU_MEAN_FAILURE";
export const REQUESTING = "Requesting";
export const SUCCESS = "Success";
export const ERROR = "Error";

export function didYouMeanRequest() {
  return {
    type: DID_YOU_MEAN_REQUEST,
    status: REQUESTING,
  };
}
export function didYouMeanSuccess(locations) {
  return {
    type: DID_YOU_MEAN_SUCCESS,
    status: SUCCESS,
    locations,
  };
}
export function didYouMeanFailure(error) {
  return {
    type: DID_YOU_MEAN_FAILURE,
    status: ERROR,
    error,
  };
}

export function didYouMean(locationText) {
  return async (dispatch) => {
    dispatch(didYouMeanRequest());
    try {
      const result = await axios.get(
        `${
          config.GATEWAY_URL
        }/${getDynamicRoute()}/api/v3/suggest?locationText=${locationText}&area_types=city,postal_code`,
      );

      const resultJson = result;
      if (resultJson.error) {
        throw new Error(resultJson.error);
      }
      return dispatch(didYouMeanSuccess(resultJson.data.autocomplete));
    } catch (e) {
      log.error(
        "Error while fetching DID_YOU_MEAN_REQUEST data for the Location : " + locationText,
        e,
      );
      dispatch(didYouMeanFailure(e.message));
    }
  };
}
